import { useRef } from "react";
import "./Value.css";
import { FaCheckSquare, FaRegCaretSquareDown } from "react-icons/fa";
const ValueType = (props) => {
  const pLink = useRef(null);
  const handleAllPs = (el) => {
    console.log(el);
    let removing = document.querySelectorAll(el.classList);
    console.log(removing);
  };
  const handleDropDwon = (e) => {
    handleAllPs(e.target.parentElement.parentElement.lastChild);
    pLink.current.classList.toggle("show");
    pLink.current.parentElement.classList.toggle("shadow");

    const rotateArrw = pLink.current.parentElement.querySelectorAll("svg")[1];
    rotateArrw.classList.toggle("rotate180");
    rotateArrw.classList.toggle("rotate0");
  };

  return (
    <div className="row-value p-2 mb-5">
      <div
        className="d-flex align-items-center justify-content-between"
        onClick={handleDropDwon}
      >
        <FaCheckSquare className="fs-3 icon" />
        <h4 className="m-0">{props.title}</h4>
        <FaRegCaretSquareDown className="fs-3 icon rotate180" />
      </div>
      <p ref={pLink} className="text-black-50 lh-1 p-3 hiddenP">
        {props.p}
      </p>
    </div>
  );
};

export default ValueType;
